export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Share progress on mobile features and blockers', frequency: 'Daily at 9 AM' },
      { name: 'Code Reviews', description: 'Review mobile code with focus on platform best practices', process: 'Minimum 1 approval from mobile team member' },
      { name: 'Sprint Planning', description: 'Plan mobile features and estimate complexity', frequency: 'Bi-weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication', channels: ['#mobile-team', '#ios-development', '#android-development'] },
      { name: 'Jira', purpose: 'Task tracking', access: 'Developer role with mobile project access' },
      { name: 'GitHub', purpose: 'Code collaboration', permissions: 'Read/Write on mobile repos' }
    ],
    processes: [
      { name: 'Feature Development', steps: ['Review designs', 'Implement for target platform', 'Test on devices', 'Submit for review'] },
      { name: 'Bug Resolution', steps: ['Reproduce on device', 'Debug using platform tools', 'Fix and test', 'Verify across devices'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Architecture Reviews', description: 'Review mobile architecture and design patterns', frequency: 'Weekly' },
      { name: 'Cross-platform Coordination', description: 'Ensure consistency between iOS and Android', commitment: 'Platform parity discussions' },
      { name: 'Performance Reviews', description: 'Monitor and optimize mobile app performance', scope: 'App performance metrics' }
    ],
    tools: [
      { name: 'Firebase Console', purpose: 'Analytics and crash reporting', access: 'Editor permissions' },
      { name: 'App Store Connect', purpose: 'iOS app management', access: 'Developer role' },
      { name: 'Google Play Console', purpose: 'Android app management', access: 'Developer role' }
    ],
    processes: [
      { name: 'Release Management', steps: ['Prepare release builds', 'Test on multiple devices', 'Submit to app stores', 'Monitor rollout'] },
      { name: 'Performance Optimization', steps: ['Profile app performance', 'Identify bottlenecks', 'Implement optimizations', 'Measure improvements'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Technical Leadership', description: 'Lead mobile platform strategy and decisions', responsibility: 'Mobile architecture ownership' },
      { name: 'Cross-team Collaboration', description: 'Coordinate with backend, design, and product teams', scope: 'Mobile integration planning' },
      { name: 'Platform Strategy', description: 'Define mobile technology roadmap', impact: 'Company mobile strategy' }
    ],
    tools: [
      { name: 'App Store Connect', purpose: 'iOS team management', access: 'Admin permissions' },
      { name: 'Google Play Console', purpose: 'Android team management', access: 'Admin permissions' },
      { name: 'Mobile Analytics Platform', purpose: 'Business intelligence', role: 'Platform admin' }
    ],
    processes: [
      { name: 'Platform Planning', steps: ['Evaluate new mobile technologies', 'Plan platform migrations', 'Define mobile standards', 'Lead adoption'] },
      { name: 'Team Scaling', steps: ['Hire mobile developers', 'Define team structure', 'Establish processes', 'Mentor team leads'] }
    ]
  }
};
